var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',{class:[`group-11-item-1`, _vm.className || ``]},[_c('div',{staticClass:"text-1 plusjakartasans-normal-cosmic-cobalt-12px"},[_vm._v(_vm._s(_vm.text5))])])
}
var staticRenderFns = []

export { render, staticRenderFns }